import './App.css';

function App() {
  return (
    <div className="App">
      Coming soon...
    </div>
  );
}

export default App;
